import { brandEndpointIds } from 'root/src/shared/brand/brand.constants';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const searchBrandsEndpoint = {
    [brandEndpointIds.SEARCH_BRANDS]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                value: {
                    type: 'string',
                },
                limit: {
                    type: 'integer',
                    minimum: 1,
                },
                page: {
                    type: 'integer',
                    minimum: 1,
                },
            },
            required: ['value', 'limit', 'page'],
        },
    },
};
